import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("bs_token", data.access_token);
      localStorage.setItem("bs_user", JSON.stringify(data.user));
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "حدث خطأ، حاول مرة أخرى");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl bg-navy-900/70 border border-white/10 px-4 py-3.5 text-sm text-white placeholder:text-white/30 focus:outline-none focus:ring-2 focus:ring-gold/60 transition-[border-color,box-shadow] duration-300";

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center px-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-20">
        <img src="https://images.unsplash.com/photo-1510851896000-498520af2236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBkYXJrfGVufDB8fHx8MTc4NjI5OTA5NHww&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative glass rounded-3xl p-10 w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="Barq Safe" className="h-20 w-20 object-contain rounded-2xl bg-white/95 p-1.5 mb-4" />
          <h1 className="font-display font-extrabold text-2xl">لوحة تحكم برق سيف</h1>
          <p className="text-sm text-white/50 mt-1">تسجيل دخول المدير</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="البريد الإلكتروني" dir="ltr" className={`${inputCls} text-left`} data-testid="admin-email-input" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="كلمة المرور" className={inputCls} data-testid="admin-password-input" />
          {error && <div className="text-red-400 text-sm bg-red-400/10 border border-red-400/20 rounded-xl px-4 py-3" data-testid="admin-login-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-gold text-navy-900 font-bold hover:bg-gold-light disabled:opacity-60 transition-colors duration-300">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={18} />}
            تسجيل الدخول
          </button>
        </form>
        <a href="/" className="block text-center text-xs text-white/40 hover:text-gold mt-6 transition-colors" data-testid="back-to-site-link">العودة إلى الموقع</a>
      </div>
    </div>
  );
}
